import React, { Fragment, useState } from 'react';
import styles from './index.module.css';
import TrackOrderStateGroup from './track-order-state-group';
import { OrderType } from 'models/order.model';
import { getDurationSince } from 'utils/functions';
import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import OrderLogsModal from '../order-logs-modal';

type Props = {
  order: OrderType;
};
const TrackOrder = ({ order }: Props) => {
  const [showModal, setShowModal] = useState(false);
  const [showLogsModal, setShowLogsModal] = useState(false);

  const timeSince =
    order.completed_time ||
    order.kitchen_dispatched_time ||
    order.kitchen_verified_time ||
    new Date();

  return (
    <div className={styles['section']}>
      <div
        className={`mx-5  ${styles['section-header-2']} py-[18px] flex-col gap-2 sm:flex-row sm:justify-between`}>
        <div className='flex gap-1'>
          <p className='text-[#858585] text-base font-medium'>Track Order</p>
          {order.created_at && (
            <p className='bg-[#F4F5F5] py-1 px-2 border border-[#EAECEC] text-xs text-[#858585] rounded-[20px]'>
              {getDurationSince(new Date(order.created_at), new Date(timeSince))}
            </p>
          )}
        </div>
        <div className='flex gap-2 items-center'>
          <button
            className='text-sm w-fit font-medium text-[#E60A2B]'
            onClick={() => setShowModal(true)}>
            View details
          </button>
          {order.order_logs?.length > 0 && (
            <Fragment>
              <span className='border-l border-gray-border inline-block h-3/5' />
              <Button
                variant='link'
                color='blue'
                onClick={() => setShowLogsModal(!showLogsModal)}
                className='flex items-center gap-1 border-b font-medium text-sm text-gray-5'>
                View logs
              </Button>
            </Fragment>
          )}
        </div>
      </div>
      <div className='py-5 lg:py-0 px-5'>
        <TrackOrderStateGroup order={order} />
      </div>
      <BaseModal
        position='right'
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false);
        }}
        title='Track Order'>
        <TrackOrderStateGroup expand={true} order={order} />
      </BaseModal>
      {showLogsModal && (
        <OrderLogsModal order={order} showModal={showLogsModal} setShowModal={setShowLogsModal} />
      )}{' '}
    </div>
  );
};

export default TrackOrder;
